import { AlertsState } from './model'
import { AppState } from '../../types'

const getBasicAlertModalState = (state: AppState): AlertsState => state.monitoring.alerts

export const isBasicAlertsEnabled = (state: AppState) => getBasicAlertModalState(state).isBasicAlertsEnabled
export const isAPIBasicAlertsEnabled = (state: AppState) => getBasicAlertModalState(state).isAPIBasicAlertsEnabled
export const isBasicAlertsLimitExceeded = (state: AppState) => getBasicAlertModalState(state).isBasicAlertsLimitExceeded
